import { createFileRoute } from "@tanstack/react-router";
import CommunityLayout from "lib/components/builders/communities/CommunityLayout";
import CommunityPlans from "lib/components/builders/communities/plans/CommunityPlans";
import withAuthentication from "../../../../../../components/withAuthentication";

function PlansPage() {
  return (
    <CommunityLayout currentPage="location_plans">
      <CommunityPlans />
    </CommunityLayout>
  );
}

export const Route = createFileRoute("/builders/$builder_id/locations/$location_id/location-plans/")({
  component: withAuthentication(PlansPage, {
    permissions: ["VIEW_COMMUNITY_PLANS"],
    resource: {
      resourceType: "communities",
      routeParamName: "location_id",
    },
  }),
});
